import styled from 'styled-components'

import Chip from '@material-ui/core/Chip'
import MuiListItem from '@material-ui/core/ListItem'
import Typography from '@material-ui/core/Typography'

import colors from '@galo-monitor/styles/colors'
import fonts from '@galo-monitor/styles/fonts'

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
  color: ${ colors.lightGrey2 };
`

export const CardTitle = styled(Typography)`
  font-weight: ${ fonts.fontWeight.bold };
`

export const CardTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ListItem = styled(MuiListItem)`
  & > * {
    color: ${ ({ color }) => `${ color } !important` };
  }
`

export const ProjectChip = styled(Chip)`
  width: max-content;
  height: 1.5rem;
  background-color: ${ ({ status }) => {
    if (status === 'waiting')
      return colors.lightGrey4
    return status === 'finished' ? colors.green2 : colors.yellow2
  } };
  color: ${ colors.white };
  font-weight: ${ fonts.fontWeight.semiBold };
`